module.exports = __webpack_public_path__ + "img/logo@3x.0106cdb6.png";